var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VideoSlide',{attrs:{"src":require('@/assets/videos/SAF-300_Ares_WhatsInItForYou_2025.mp4'),"vtt":require('@/assets/videos/SAF-300_Ares_WhatsInItForYou_2025.vtt'),"background-theme":"dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }